import { useQuery } from '@tanstack/react-query';
import { ambientApi } from 'src/services';
import { UseQueryOverrideOptions } from '../common';

type UseGetProTrialEntitlementResponse = {
  entitled?: boolean;
};

export const useGetProTrialEntitlement = (
  _unused?: unknown,
  options: UseQueryOverrideOptions = {}
) => {
  return useQuery({
    ...options,
    queryKey: ['proTrialEntitlement'],
    queryFn: () =>
      ambientApi
        .get<UseGetProTrialEntitlementResponse>('/aura_pro_trial/entitlement')
        .then((res) => res.data),
  });
};
